import * as React from "react";
import styled from "styled-components";

import Gettext from "../common/Gettext";
import { Remove, HorizontalLine } from "./Tools";
import HideTool from "./HideTool";
import { fontSize } from "../common/styled-mixins";

const Container = styled.div`
  position: absolute;
  top: 38px;
  left: 0;
  background-color: ${props => props.theme.popupDarkBackground};
  color: ${({ theme }) => theme.foreground};
  font-size: ${fontSize(12)};
  line-height: 1;
  padding: 10px;
  z-index: 2;
  width: 270px;
`;

const HeadToolsContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Heading = styled.div`
  direction: ${props => props.theme.direction};
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  align-self: flex-start;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 9px 11px;
  font-size: ${fontSize(14)};
  line-height: 1;
  color: ${props => props.theme.accent};
  border-bottom: 1px solid ${props => props.theme.mainSeparator};

  @media (min-width: 960px) {
    height: 25px;
    padding: 0 4px;
  }
`;

const InnerContent = styled.div`
  flex-grow: 1;
  flex-shrink: 0;
  padding: 8px 0 0;
  width: 100%;

  // @media (min-width: 960px) {
  //   overflow: hidden;
  // }

  @media (max-width: 959px) {
    overflow: auto;
  }
`;

class GraphicalTools extends React.Component {
  state = {
    coolTool: null
  };

  render() {
    const props = this.props;

    const tool =
      (this.state.coolTool != null &&
        props.settings.graphicalTools &&
        props.settings.graphicalTools[props.stock] &&
        props.settings.graphicalTools[props.stock].tools &&
        props.settings.graphicalTools[props.stock].tools[
          this.state.coolTool.index
        ]) ||
      null;

    return (
      <Container>
        <Heading>
          <Gettext>Horizontal line</Gettext>
          <HeadToolsContainer>
            {props.settings.graphicalTools &&
              props.settings.graphicalTools[props.stock] &&
              props.settings.graphicalTools[props.stock].tools.length > 0 && (
                <React.Fragment>
                  <HideTool
                    style={{
                      marginRight: 8,
                      marginTop: -1
                    }}
                    value={
                      props.settings.graphicalTools[props.stock].enabled !==
                      false
                    }
                    onClick={value =>
                      props.dispatch({
                        type: "SET_GRAPHICAL_TOOLS_VISIBILITY",
                        payload: {
                          stock: props.stock,
                          value
                        }
                      })
                    }
                  />
                  <Remove
                    onClick={() => {
                      props.dispatch({
                        type: "CLEAR_GRAPHICAL_TOOLS",
                        payload: {
                          activeStock: props.stock
                        }
                      });
                    }}
                  />
                </React.Fragment>
              )}
          </HeadToolsContainer>
        </Heading>

        <InnerContent>
          <HorizontalLine
            dispatch={props.dispatch}
            graphicalMode={props.graphicalMode || {}}
            onToolCoolClick={(tool, index) => {
              if (tool != null && index != null) {
                this.setState({ coolTool: { tool, index } });
              } else {
                this.setState({ coolTool: null });
              }
            }}
            editMode={
              (tool != null && {
                tool,
                index: this.state.coolTool.index
              }) ||
              null
            }
            tools={
              (props.settings.graphicalTools &&
                props.settings.graphicalTools[props.stock] &&
                props.settings.graphicalTools[props.stock].tools) ||
              []
            }
            onClick={() => {
              this.setState({ coolTool: null });

              const resetGraphicalTool = () => {
                props.unlockOutsideClick();

                props.dispatch({
                  type: "SET_GRAPHICAL_MODE",
                  payload: null
                });

                document.removeEventListener("click", resetGraphicalTool);
              };

              if (!props.graphicalMode.graphicalTool) {
                // Reset graphical mode on any click
                document.addEventListener("click", resetGraphicalTool);

                props.lockOutsideClick();

                props.dispatch({
                  type: "SET_GRAPHICAL_MODE",
                  payload: "horizontalLine"
                  // type: "PUSH_GRAPHICAL_TOOL",
                  // payload: {
                  //   type: "horizontalLine",
                  //   anchorValue: this.props.lastPointValue
                  // }
                });
              }
            }}
          />
        </InnerContent>
      </Container>
    );
  }
}

export default GraphicalTools;



// WEBPACK FOOTER //
// ./src/components/Toolbar/GraphicalTools.js